import {Model} from '@nozbe/watermelondb';
import {field} from '@nozbe/watermelondb/decorators';

class User extends Model {
  static table = 'users';

  @field('user_id')
  user_id: string;

  @field('name')
  name: string;

  @field('cpf')
  cpf: string;

  @field('email')
  email: string;

  @field('phone')
  phone: string;

  @field('avatarUrl')
  avatarUrl: string;

  @field('token')
  token: string;

  @field('codCompartilhar')
  codCompartilhar: string;

  @field('phone_verified')
  phone_verified: boolean;
}

export {User};
